// extracted by css-extract-rspack-plugin
export default {"cls1":"MarketingPageLayout-cls1_AUe","cls2":"MarketingPageLayout-cls2_WhE MarketingPageLayout-cls1_AUe"};